const CLIENT_SELECT_PAGE_SIZE = 1000;

export function isActiveClientStatus(status) {
  return String(status || '').trim().toLowerCase() === 'active';
}

export function sortClientsForSelect(clients) {
  return [...clients].sort((a, b) => {
    const aActive = isActiveClientStatus(a.status) ? 0 : 1;
    const bActive = isActiveClientStatus(b.status) ? 0 : 1;
    if (aActive !== bActive) return aActive - bActive;
    return (a.name || '').localeCompare(b.name || '');
  });
}

async function fetchClientsPaginated(supabase) {
  const allClients = [];
  let from = 0;

  while (true) {
    const { data, error } = await supabase
      .from('clients')
      .select('id, name, status')
      .order('name')
      .range(from, from + CLIENT_SELECT_PAGE_SIZE - 1);

    if (error) throw error;

    const page = data || [];
    allClients.push(...page);

    if (page.length < CLIENT_SELECT_PAGE_SIZE) {
      break;
    }

    from += CLIENT_SELECT_PAGE_SIZE;
  }

  return allClients;
}

/**
 * Loads all clients for dropdowns, including inactive.
 * Prefers the get_all_clients_for_select RPC (SECURITY DEFINER) when available
 * so inactive clients are not hidden by RLS policies on the clients table.
 */
export async function fetchClientsForSelect(supabase) {
  const { data: rpcData, error: rpcError } = await supabase.rpc('get_all_clients_for_select');

  if (!rpcError && Array.isArray(rpcData)) {
    return sortClientsForSelect(rpcData);
  }

  if (rpcError && rpcError.code !== 'PGRST202') {
    console.warn('get_all_clients_for_select RPC unavailable, falling back to clients query:', rpcError.message);
  }

  return sortClientsForSelect(await fetchClientsPaginated(supabase));
}
